import de from './de.json';
import en from './en.json';

const messages = { de, en };

export default { messages, invariant: 'de' };



// WEBPACK FOOTER //
// ./src/app/@amarc21/locales/index.js